// extracted by mini-css-extract-plugin
export default {"root":"uqvwj","avatar":"yB8YC","avatarLiveBadge":"_vxAi","userName":"AeBNH"};